// Spec §3 — canonical tab→page-index map. Single source of truth for App.js
// routing (render gates, goToPage, default landing) and TabBar active mapping.
// Order is the App.js `page` state contract, not the visual tab-bar order
// (IMPORT sits between BETS and RESEARCH visually but is a modal, not a page).
export const PAGE = {
  HOME: 0,
  BETS: 1,
  RESEARCH: 2,
  HISTORY: 3,
  BOOKIES: 4,
};
